import { render, staticRenderFns } from "./SearchType.vue?vue&type=template&id=063c7129&scoped=true&"
import script from "./SearchType.vue?vue&type=script&lang=ts&"
export * from "./SearchType.vue?vue&type=script&lang=ts&"
import style1 from "./SearchType.vue?vue&type=style&index=1&id=063c7129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063c7129",
  null
  
)

export default component.exports